import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78cc7aee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=78cc7aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cc7aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cc7aee')) {
      api.createRecord('78cc7aee', component.options)
    } else {
      api.reload('78cc7aee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78cc7aee&scoped=true&", function () {
      api.rerender('78cc7aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wxstatistics/index.vue"
export default component.exports